import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./toast.css";

/* Toasts "Signal" (design 5a — Notifications).
   Usage : toast("ok"|"err"|"warn"|"info", title, body?, { ttl, action:{label,onClick} }) */

let pushFn = null;

export const toast = (type, title, body, opts = {}) => {
  if (pushFn) pushFn({ id: Date.now() + Math.random(), type, title, body, ...opts });
};

// hook debug (console) : window.__sgToast("ok","Titre","corps")
if (typeof window !== "undefined") window.__sgToast = toast;

export const ToastHost = () => {
  const { t: tr } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    pushFn = (t) => {
      setItems((cur) => [...cur.slice(-3), t]); // max 4 toasts empilés
      const ttl = t.ttl ?? 5000;
      if (ttl > 0) {
        setTimeout(() => {
          setItems((cur) => cur.filter((x) => x.id !== t.id));
        }, ttl);
      }
    };
    return () => {
      pushFn = null;
    };
  }, []);

  const close = (id) => setItems((cur) => cur.filter((x) => x.id !== id));

  if (items.length === 0) return null;

  return (
    <div className="sg-toasts">
      {items.map((t) => (
        <div key={t.id} className={`sg-toast sg-toast--${t.type}`}>
          <span className="sg-toast__dot" />
          <div className="sg-toast__txt">
            <div className="sg-toast__title">{t.title}</div>
            {t.body ? <div className="sg-toast__body">{t.body}</div> : null}
            {t.action ? (
              <button
                className="sg-toast__action"
                onClick={() => {
                  t.action.onClick();
                  close(t.id);
                }}
              >
                {t.action.label}
              </button>
            ) : null}
          </div>
          <button className="sg-toast__close" onClick={() => close(t.id)} aria-label={tr("signal.close")}>
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};
